import script from "./DataTableExtin.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTableExtin.vue?vue&type=script&setup=true&lang=js"

import "./DataTableExtin.vue?vue&type=style&index=0&id=6b7a5045&lang=scss"

const __exports__ = script;

export default __exports__